import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatDrawer } from '@angular/material/sidenav';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { IdentityService } from 'src/app/core/services/identity.service';
import { LoginService } from 'src/app/core/services/login.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ScriptService } from 'src/app/core/services/script.service';
import { SideNavHideService } from 'src/app/core/services/sideNavHide.service';
import { InboxService } from '../../../pages/inbox/services/inbox.service';
import { SCRIPT_NAMES } from '../../constants/script-store';
import { User } from '../../models/user';
import { DetailPaymentService } from 'src/app/pages/detail-pay/services/detail.payment.service';
import { ConfirmarDialogComponent } from '../../../shared/components/confirmar-dialog/confirmar-dialog.component';
import { Permissions } from '../../enums/permissions.enum';
import { RolesWeb } from '../../enums/roles.enum';

const PIX_PAY_URL = '/user/pix-pay';
export interface Options {
  heading?: string;
  removeFooter?: boolean;
  mapHeader?: boolean;
}
@Component({
  selector: 'app-panel-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LayoutComponent implements OnInit, AfterViewInit {
  @ViewChild('scrollable') scrollable: ElementRef;
  @ViewChild('drawer') drawer: MatDrawer;

  contanerId = 'page-content-wrapper';
  currentNav: string = '';
  isPixPayNav: boolean;
  loggedUser: User;
  mobileMode: boolean;
  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;
  scrollToMessageSubscription$: Subscription;
  showSubMenuComercio = false;
  permissions = Permissions;

  get user(): string {
    return this.loggedUser.email;
  }

  get toggle(): boolean {
    return this.sidebarService.hideSideNav;
  }

  constructor(
    public sidebarService: SideNavHideService,
    private router: Router,
    public dialog: MatDialog,
    public login: LoginService,
    public identityService: IdentityService,
    private translateService: TranslateService,
    private inboxService: InboxService,
    private scriptService: ScriptService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private detailStorage: DetailPaymentService,
    private dialogConfirm: MatDialogRef<ConfirmarDialogComponent>
  ) {}

  async ngOnInit() {
    this.route.url.subscribe(() => {
      this.currentNav = this.router.url;
      this.isPixPayNav = this.currentNav == PIX_PAY_URL;
      this.isPixPayNav ? (this.contanerId = 'default-container') : (this.contanerId = 'page-content-wrapper');
    });
    this.loggedUser = this.identityService.getUser();
    this.initMobileMode();
    await this.scriptService.load(SCRIPT_NAMES.GOOGLE_MAPS);
    this.currentNav = this.router.url;
  }

  disableNavigation(): boolean {
    const user = this.identityService.getUser();
    return user && user.organismo && !user.organismo.rubro;
  }

  ngAfterViewInit() {
    this.scrollToMessageSubscription$ = this.inboxService.getScrollToMessage().subscribe(() => {
      if (this.mobileMode) {
        this.scrollable.nativeElement.scrollTop = this.scrollable.nativeElement.scrollHeight;
      }
    });
  }

  initMobileMode() {
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.resizeSubscription$ = this.resizeObservable$.subscribe((evt: any) => {
      if (evt.target.innerWidth < 700) {
        this.sidebarService.hide();
        this.mobileMode = true;
      } else {
        this.sidebarService.show();
        this.mobileMode = false;
      }
    });

    if (window.innerWidth < 700) {
      this.mobileMode = true;
    } else {
      this.mobileMode = false;
    }
  }

  get loginService() {
    return this.login;
  }

  //#region NAVIGATION

  navigate(url: string): void {
    const user = this.identityService.getUser();
    this.detailStorage.resetStorageFilterParameters();
    this.detailStorage.storage = null;

    if (!(user.organismo && !user.organismo.rubro)) {
      if (url == '/user/movements') {
        this.router.navigate(['/user/movements/'], { queryParams: { page: '1' } });
      } else {
        this.router.navigate([url]);
      }

      this.drawer.close();
      this.currentNav = url;
    } else if (this.identityService.hasRolId(RolesWeb.RESPONSABLE)) {
      this.router.navigate([url]);
    } else {
      this.notificationService.showWarning(
        this.translate('components.layout.complete-profile-msg'),
        this.translate('components.layout.complete-profile-title')
      );
      this.currentNav = '/user/my-commerce';
    }
  }

  //#endregion NAVIGATION

  closeSessionEventHandler(): void {
    this.dialogConfirm = this.dialog.open(ConfirmarDialogComponent, {
      data: {
        info: '',
        title: '¿Está seguro que desea cerrar sesión?',
        button: 'Confirmar'
      }
    });

    this.dialogConfirm.afterClosed().subscribe((result) => {
      if (result) {
        this.login.endSession();
      }
    });
  }

  translate(key: string): string {
    return this.translateService.instant(key);
  }

  toggleSubMenuComercio() {
    this.showSubMenuComercio = !this.showSubMenuComercio;
  }

  hasPermission(permission: Permissions): boolean {
    return this.identityService.hasPermission(permission);
  }
}
